<div class="app-isf-docs-strip" [ngStyle]="{ top: topOffset + 'px' }">
  <loading-spinner [show]="isLoading"></loading-spinner>
  <ng-container *ngIf="!isLoading">
    <div [ngClass]="{ hidden: isHideScrollLeft }" class="app-isf-docs-strip__left-navigation-button" (click)="scrollToDirection('left')">
      <img src="assets/icons/icon_arrow_left_sm_gray.svg" alt="left-navigation" />
    </div>

    <div
      appScrollListener
      appOverflowListener
      (overflowChange)="onOverflowChange($event)"
      (scrolledToStart)="onScrolledToStart()"
      (scrolling)="onScrolling($event)"
      (scrolledToEnd)="onScrolledToEnd()"
      class="app-isf-docs-strip__container"
      #scrollContainer
    >
      <div class="app-isf-docs-strip__section" id="app-isf-docs-strip-section">
        <div class="app-isf-docs-strip__items" *ngIf="!!isfDocuments">
          <div
            *ngFor="let doc of isfDocuments"
            class="app-isf-docs-strip__drop-zone"
            [class.is-drag-over]="dragOverCardKey === getDropZoneKey(doc)"
            (dragover)="onDragOver($event, doc)"
            (drop)="onDrop($event, doc)"
            (dragleave)="onDragLeave($event)"
          >
            <app-document-upload-preview
              [id]="'isf-doc-' + isf.id + '-' + doc.type + '-' + doc.id"
              [uploadedDocument]="document(doc, isf.id)"
              [fileExtensionIgnoreList]="fileExtensionIgnoreList"
              [fileMimeIgnoreList]="fileMimeIgnoreList"
              tagText="LABELS.OPTIONAL"
              [labelText]="documentName(doc)"
              [documentPreviewUrl]="documentPreviewUrl(doc)"
              [uploadingStatusText]="documentUploadingStatusText"
              [isLoading]="isLoading || isDocumentUploadLoading(doc)"
              [isClickOnly]="true"
              [isDragOver]="dragOverCardKey === getDropZoneKey(doc)"
              (click)="onDocumentUploadClick(doc)"
              (delete)="deleteDocument($event)"
              (preview)="onPreviewDocument(doc)"
              (stateUpdate)="updateDocumentState($event, doc)"
            ></app-document-upload-preview>
          </div>

          <div
            *ngFor="let doc of getPendingAdditionalDocs(); trackBy: trackByPendingDoc"
            class="app-isf-docs-strip__drop-zone"
            [class.is-drag-over]="dragOverCardKey === getDropZoneKey(doc)"
            (dragover)="onDragOver($event, doc)"
            (drop)="onDrop($event, doc)"
            (dragleave)="onDragLeave($event)"
          >
            <app-document-upload-preview
              [id]="'isf-pending-doc-' + isf.id + '-' + doc.type + '-' + doc.id"
              [uploadedDocument]="document(doc, isf.id) || doc"
              [fileExtensionIgnoreList]="fileExtensionIgnoreList"
              [fileMimeIgnoreList]="fileMimeIgnoreList"
              [tagType]="''"
              [tagText]="'LABELS.OPTIONAL'"
              [labelText]="documentName(doc, pendingDocNumber(doc))"
              [documentPreviewUrl]="documentPreviewUrl(doc)"
              [uploadingStatusText]="documentUploadingStatusText"
              [isLoading]="isLoading || isDocumentUploadLoading(doc)"
              [isClickOnly]="true"
              [isDragOver]="dragOverCardKey === getDropZoneKey(doc)"
              [showDeleteWhenEmpty]="true"
              (click)="onPendingAdditionalDocClick(doc)"
              (delete)="removePendingAdditionalDoc($event)"
            ></app-document-upload-preview>
          </div>

          <app-document-upload-preview
            [id]="'isf-additional-doc-input-' + isf.id"
            type="multiple"
            [multipleFileOptions]="additionalDocumentSelectItems"
            [fileExtensionIgnoreList]="fileExtensionIgnoreList"
            [fileMimeIgnoreList]="fileMimeIgnoreList"
            [multipleDocSelectTypes]="scannableAdditionalDocs"
            [changeCounter]="documentChangeCounter"
            labelText="BUTTON.ADD_OTHER_DOCUMENT"
            [isLoading]="isLoadingAdditionalDocUploadFlags.get('isf-additional-doc-input-' + isf.id)"
            (click)="onAdditionalDocClick()"
            (upload)="uploadAdditionalDocument($event)"
            (multipleDocTypeSelect)="onMultipleDocTypeSelect($event)"
          ></app-document-upload-preview>
        </div>
      </div>
    </div>

    <div [ngClass]="{ hidden: isHideScrollRight }" class="app-isf-docs-strip__right-navigation-button" (click)="scrollToDirection('right')">
      <img src="assets/icons/icon_arrow_left_sm_gray.svg" alt="right-navigation" />
    </div>
    <input #pendingNonOcrFileInput type="file" class="d-none" (change)="onPendingNonOcrFileChange($event)" />
  </ng-container>
</div>

<custom-modal modalClass="app-isf-docs-strip__upload-modal" [(open)]="isOpenUploadModal" [header]="documentUploadModalHeader" size="md">
  <div class="app-isf-docs-strip__upload-modal__body">
    <div class="app-isf-docs-strip__upload-modal__content">
      <p class="app-isf-docs-strip__upload-modal__description">
        {{
          "DOCUMENT_UPLOAD_MODAL.DESCRIPTION"
            | translate
              : {
                  documentName: (documentLabel(currentDocument?.type) | translate)
                }
        }}
      </p>
      <p class="app-isf-docs-strip__upload-modal__hint">
        {{ "DOCUMENT_UPLOAD_MODAL.HINT" | translate }}
      </p>
      <div class="app-isf-docs-strip__upload-modal__checkbox custom-control custom-checkbox pl-4">
        <input type="checkbox" [formControl]="skipOcrScanControl" class="custom-control-input" id="skipOcrScan" />
        <label class="custom-control-label" for="skipOcrScan">
          {{ "LABELS.SKIP_OCR_SCANNING" | translate }}
        </label>
      </div>
    </div>

    <div class="app-isf-docs-strip__upload-modal__actions">
      <app-document-browse-button
        footer-action
        [changeCounter]="documentChangeCounter"
        [fileExtensionIgnoreList]="fileExtensionIgnoreList"
        [fileMimeIgnoreList]="fileMimeIgnoreList"
        [preSelectedFile]="pendingDroppedFile"
        (browse)="onBrowse($event)"
        (replace)="setIsOpenUploadModal(true)"
        (fail)="setIsOpenUploadModal(false)"
      ></app-document-browse-button>
    </div>
  </div>
</custom-modal>

<custom-toast
  type="alert"
  [message]="invalidFileErrorMessage"
  [duration]="0"
  [open]="isShowInvalidFileToast"
  (close)="dismissInvalidFileToast()"
></custom-toast>

<app-documents-preview-modal
  [open]="isOpenDocsPreviewModal"
  [index]="currentPreviewModalDocIndex"
  [previewDocs]="isfPreviewModalDocs"
  (close)="setIsOpenDocsPreviewModal(false)"
  (delete)="onPreviewDocumentDelete($event)"
></app-documents-preview-modal>
